"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var MainContainer = styled_components_1.default.aside(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n\n  ", "\n"], ["\n  position: absolute;\n\n  ",
    "\n"])), function (_a) {
    var position = _a.position;
    var top = 50;
    switch (position) {
        case "center":
            break;
        case "top":
            top = 25;
        case "bottom":
            top = 75;
    }
    return "\n      top: " + top + "%;\n      left: 50%;\n      transform: translate(-50%, -50%);\n    ";
});
function CarouselCaption(_a) {
    var children = _a.children, _b = _a.position, position = _b === void 0 ? "center" : _b, style = _a.style, className = _a.className;
    return (react_1.default.createElement(MainContainer, { position: position, className: className, style: style }, children));
}
exports.default = CarouselCaption;
var templateObject_1;
//# sourceMappingURL=index.js.map